import auth from "./api/AuthAPI";
import common from "./api/CommonAPI";
import main from "./api/MainAPI";
export default {
    auth,
    common,
    main
}
